import type { ReactNode } from 'react';

export const symbol_joystick: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m225-436 255 147 254-148-224-129v146h-60v-146L225-436Zm225-199v-28q-43-11-71.5-45.99T350-790q0-53.86 38.1-91.93 38.1-38.07 92-38.07t91.9 38.07q38 38.07 38 91.93 0 46.02-28.5 81.01T510-663v28l300 173q14.25 8.17 22.13 21.91Q840-426.34 840-410v100q0 16.34-7.87 30.09Q824.25-266.17 810-258L510-85q-14.33 8-30.16 8Q464-77 450-85L150-258q-14.25-8.17-22.12-21.91Q120-293.66 120-310v-100q0-16.34 7.88-30.09Q135.75-453.83 150-462l300-173Zm0 397L180-393v83l300 173 300-173v-84L510-238q-14.33 8-30.16 8-15.84 0-29.84-8Zm79.5-502.38q20.5-20.38 20.5-49.5t-20.38-49.62q-20.38-20.5-49.5-20.5t-49.62 20.38q-20.5 20.38-20.5 49.5t20.38 49.62q20.38 20.5 49.5 20.5t49.62-20.38ZM480-137Z"
		/>
	</svg>
);
